module.exports = __webpack_public_path__ + "media/images/donation/logo-rakuten-91e00b6bf8913a509c8ecb7de8e57b66.jpg";